import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import DataHelper, { DataHelperConfiguration } from "@Scripts/Common/DataHelper";

@Component({ name: "MyGeoMarker" })
export default class MyGeoMarker extends Vue {
    public localizer: any = Localizer;
    public isGooglePlaceIdDisabled: boolean = true;
    public isLoading: boolean = true;
    public isLoadingForm: boolean = false;
    public isSuccess: boolean = false;
    public geoMarker: any = { isPageLive: false, stockImageIdMaster: null };
    public stockImages: any[] = [];
    public geoMarkerServices: any[] = [];
    public geoMarkerTypes: any[] = [];
    public geoMarkerMarkets: any[] = [];
    public geoMarkerMarketTypes: any[] = [];
    public validationErrors: any[] = [];

    public isShowroomEdit: boolean = false;
    public isPageLive: boolean = false;
    public isSlugDisabled: boolean = false;
    public stockImageIdMaster: string = null;
    public openingTimes: any = [];
    public specialDayEdit: any = {};

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.MyBremboPartsExpert_MyGeoMarkerData)).data;
        this.geoMarker = result.geoMarker;
        this.stockImages = result.stockImages;
        this.geoMarkerServices = result.geoMarkerServices;
        this.geoMarkerTypes = result.geoMarkerTypes;
        this.geoMarkerMarkets = result.geoMarkerMarkets;
        this.geoMarkerMarketTypes = result.geoMarkerMarketTypes;

        this.openingTimes = this.geoMarker.openingTimes;

        this.geoMarker.isPageLive = result.expertPage.isPageLive;
        this.geoMarker.slug = result.expertPage.slug;
        this.geoMarker.stockImageIdMaster = result.expertPage.stockImageIdMaster;

        this.isPageLive = result.expertPage.isPageLive;
        this.isSlugDisabled = result.expertPage.idMaster !== '-1';
        this.stockImageIdMaster = result.expertPage.stockImageIdMaster;

        this.isLoading = false;
    }

    public async saveSpecialDay() {
        if ((this.specialDayEdit.specialDay == undefined || this.specialDayEdit.specialDay == null)) {
            this.$store.dispatch("bremboToastStore/onAddToast", { message: this.localizer.get("App.MyBremboParts.Date_Required"), type: "Error" });
            return;
        }

        this.openingTimes.push({
            type: "SpecialDay",
            weekDay: null,
            specialDay: this.specialDayEdit.specialDay,
            morningOpeningTime: this.specialDayEdit.morningOpeningTime,
            morningClosingTime: this.specialDayEdit.morningClosingTime,
            eveningOpeningTime: this.specialDayEdit.eveningOpeningTime,
            eveningClosingTime: this.specialDayEdit.eveningClosingTime
        });

        this.specialDayEdit = { specialDay: null, morningOpeningTime: null, morningClosingTime: null, eveningOpeningTime: null, eveningClosingTime: null };

        await this.submitForm();
    }

    public async deleteSpecialDay(index: number) {
        this.openingTimes.splice(index, 1);
        await this.submitForm();
    }

    public async saveEdit() {
        await this.submitForm();
        this.isShowroomEdit = false;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        this.geoMarker.openingTimes = JSON.stringify(this.openingTimes);

        try {
            await Axios.post(this.routes.MyBremboPartsExpert_SaveEditGeoMarker, this.geoMarker);

            await this.getData();

            this.$store.dispatch("bremboToastStore/onAddToast", { message: this.localizer.get("App.MyBremboParts.Success"), type: "Success" });
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoadingForm = false;
    }

    public async updateGooglePlaceId() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoadingForm = true;

        if (confirm(this.localizer.get("App.MyBremboParts.GooglePlaceId_UpdateConfrim")) == true) {
            try {
                await Axios.post(this.routes.MyBremboPartsExpert_UpdateGooglePlaceId, this.geoMarker);

                location.reload();
            } catch (error) {
                if (error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        }

        this.isLoadingForm = false;
    }

    public showEdit() {
        this.isShowroomEdit = !this.isShowroomEdit;
    }

    public getDayOfWeek(dayNumber: number): string {
        const days = [
            this.localizer.get("App.MyBremboParts.Expert_DayOfWeek_Sunday"),
            this.localizer.get("App.MyBremboParts.Expert_DayOfWeek_Monday"),
            this.localizer.get("App.MyBremboParts.Expert_DayOfWeek_Tuesday"),
            this.localizer.get("App.MyBremboParts.Expert_DayOfWeek_Wednesday"),
            this.localizer.get("App.MyBremboParts.Expert_DayOfWeek_Thursday"),
            this.localizer.get("App.MyBremboParts.Expert_DayOfWeek_Friday"),
            this.localizer.get("App.MyBremboParts.Expert_DayOfWeek_Saturday")
        ];

        if (dayNumber < 0 || dayNumber > 6) {
            return "";
        }

        return days[dayNumber];
    }

    public isValidSlug() {
        const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

        if (!slugRegex.test(this.geoMarker.slug)) {
            this.validationErrors.push({ name: "Slug", message: this.localizer.get("App.MyBremboParts.Slug_NotValid") });
        } else {
            this.validationErrors = [];
        }
    }

    public setImageId(stockImageIdMaster: string) {
        this.geoMarker.stockImageIdMaster = stockImageIdMaster;
        this.stockImageIdMaster = stockImageIdMaster;
    }

    public isPageLiveUpdate() {
        this.isPageLive = this.geoMarker.isPageLive;
    }

    public formatDate(data: string) {
        let dataConfiguration: DataHelperConfiguration = { culture: (<any>window).App.culture };

        return DataHelper.convertDateToString(data, dataConfiguration, true).slice(0, 10);
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};